/**
 * Pre-compiled pt-BR messages for ScopedSearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { searchLabel: `Pesquisa`, selectLabel: `Filtrar por` };
